<div [class]="getAlignClass()" (click)="check()" [class.readonly]="readOnly" [class.disabled]="disabled"
    [class.alternative]="alternative">
    <div class="app-radio-indicator" [class.active]="checked" [class.multiple]="multiple">
        <i class="app-radio-icon fas fa-check"></i>
    </div>
    <ng-content></ng-content>
</div>